import Terminals from "pages/terminals/terminals";
import Webhooks from "pages/webhooks/webhooks";

export const PATHS = {
    Global: {
        Login: "/login",
        ForgotPassword: "/forgot-password",
        ResetPassword: "/reset-password",
        ConfirmAccount: "/confirm-account",
        NotFound: "/not-found",
    },
    Portal: {
        Index: "/",
        Dashboard: "/",
        Payments: "/payments",
        Agreements: "/agreements",
        PartnerAgreementDetails: "/agreements/:partnerContractId",
        Settlements: "/settlements",
        MerchantSettlements: "/merchant-settlements",
        Terminals: "/terminals",
        Transactions: "/transactions",
        Users: "/users",
        ApiKeys: "/api-keys",
        Notifications: "/notifications",
        Settings: "/settings",
        MerchantAgreements: "/merchant-agreements",
        Webhooks: "/webhooks",
    },
};
